<div class="container">
  <div>
    <div
      fxLayout="row"
      fxLayoutAlign="space-around center"
      style="height: 100px"
    >
      <img fxFlex="20" src="assets/MSGI.jpg" />
      <h1
        fxFlex="60"
        class="title"
        style="
          text-align: center;
          font-size: 50px;
          font-family: fantasy, Helvetica, sans-serif;
        "
      >
        Suivi atelier
      </h1>
      <p fxFlex="20" class="title" style="text-align: center">
        {{ dateAujourdhui }}
      </p>
    </div>
  </div>

  <br />
  <div
    style="padding-right: 40px"
    fxLayout="row"
    fxLayoutAlign="end center"
    fxLayoutGap="20px"
  >
    <span style="width: 30px; height: 30px; background: #555"></span>
    <a style="font-size: 28px">Inactif</a>
    <span
      style="width: 30px; height: 30px; background: rgb(18, 151, 18)"
    ></span>
    <a style="font-size: 28px">Actif</a>
    <span
      style="width: 30px; height: 30px; background: rgb(192, 192, 25)"
    ></span>
    <a style="font-size: 28px">En attente</a>
    <span
      style="width: 30px; height: 30px; background: rgb(218, 43, 43)"
    ></span>
    <a style="font-size: 28px">En panne</a>
  </div>

  <br />
  <br />

  <div fxLayout="column" fxLayoutGap="60px">
    <div fxLayout="row" fxLayoutAlign="center stretch" fxLayoutGap="15px">
      <div
        *ngIf="chargement_mensuel != null"
        class="card h-100 text-center"
        fxFlex="25"
      >
        <div
          class="card-header h4 text-white"
          style="background-color: #0d47a1"
        >
          <p>Usine</p>
        </div>
        <div class="card-body">
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            fxLayoutGap="20px"
            style="line-height: 40px"
          >
            <a style="font-size: 3vw">Réalisé / Objectif (T) :</a>
            <a style="font-size: 2vw">
              {{ chargement_mensuel }} / {{ objectif_atelier }}</a
            >
          </div>
        </div>
      </div>
    </div>

    <div
      *ngFor="let LigneFab of LignesFabricationsIds"
      fxLayout="row"
      fxLayoutAlign="center center"
      style="padding-left: 20px; padding-right: 20px"
      fxLayoutGap="15px"
    >
      <div
        *ngIf="poidsParLigne != null"
        class="card h-100 text-center"
        fxFlex="8"
      >
        <div
          class="card-header h4 text-white"
          style="background-color: #0d47a1"
        >
          <p>Ligne {{ LigneFab }}</p>
        </div>
        <div class="card-body">
          <a style="font-size: 24px">
            {{ getPoidsParLigne(LigneFab) / 1000 }} T</a
          >
        </div>
      </div>

      <div
        *ngFor="let col of getColumnsByLigneFab(LigneFab)"
        fxLayout="column"
        fxLayoutGap="15px"
        fxLayoutAlign="center stretch"
        fxFlex="18"
      >
        <div *ngFor="let item of getItemsByLigneFab(LigneFab, col)">
          <div class="card h-100 text-center">
            <div
              class="card-header h4 text-white"
              [ngClass]="
                item.TempsTheoriqueTravaille != '0' ? 'bg-success' : 'bg-grey'
              "
            >
              <p>{{ item.Machine_Code }}</p>
            </div>

            <div class="card-body">
              <div fxLayout="row" fxLayoutAlign="space-evenly center">
                <div fxLayout="column" fxLayoutGap="20px">
                  <div fxFlex="50" fxLayout="column" fxLayoutGap="20px">
                    <a>TRS</a>
                    <p
                      class="big-text"
                      [ngStyle]="{
                        color:
                          item.TRS < 50
                            ? 'crimson'
                            : item.TRS <= 80
                            ? 'darkorange'
                            : 'forestgreen'
                      }"
                    >
                      {{ item.TRS }}%
                    </p>
                  </div>

                  <div fxFlex="50" fxLayout="column" fxLayoutGap="20px">
                    <a>TRG</a>
                    <p
                      class="big-text"
                      [ngStyle]="{
                        color:
                          item.TRS < 50
                            ? 'crimson'
                            : item.TRS <= 80
                            ? 'darkorange'
                            : 'forestgreen'
                      }"
                    >
                      {{ item.TRG }}%
                    </p>
                  </div>
                </div>

                <div *ngIf="item.TempsTheoriqueTravaille != '0'">
                  <div
                    *ngIf="item.TempsTheoriqueTravaille != '0'"
                    style="font-size: 24px"
                  >
                    {{ item.dernier_OF_Num }}
                  </div>
                  <br />
                  <div
                    *ngFor="let user of item.ConnectedUsers"
                    style="font-size: 24px"
                  >
                    <p>{{ user.Perso_Nom }} {{ user.Perso_Prenom }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br />
  <br />
</div>
